import React from 'react'
import { ComingSoon } from '../../../Components'

export default function CareerGuidance() {
    return (
        <div>
            <ComingSoon />
        </div>
    )
}
